import AppRouter from "./App.router";
export default AppRouter;
